const trackingUtils = require('od-modules/utils/tracking.utils');
const {availability, brokenFlow, validation} = require('../../data/dynpack_errors');
const ERRORS = [...availability, ...brokenFlow, ...validation];

const errorsHandler = (errors) => {
    if (Odigeo._.isArray(errors)) {
        trackingErrors(errors);
        notifyErrors(getErrorsByType(errors));
    }
};

const trackingErrors = (errors) => {
    errors.forEach((error) => trackingUtils.trackEvent(
        'dynpack-shopping-cart-error',
        error.message,
    ));
};

const getErrorsByType = (errors) => (
    _(errors).groupBy('type').mapValues((listError) => Odigeo._.map(listError, 'message')).value()
);

const notifyErrors = (errorsByType) => {
    Object.keys(errorsByType).forEach((type) => {
        Odigeo.trigger(
            `dynpack-shopping-cart:${Odigeo._.kebabCase(type)}`,
            errorsByType[type]
        );
    });
};

const hasErrorsByTypeMessage = ({type, message}) => Odigeo._.some(ERRORS, {type, message});

const getErrorByMessage = (message) => Odigeo._.findWhere(ERRORS, {message});

module.exports = {
    errorsHandler,
    hasErrorsByTypeMessage,
    getErrorByMessage,
};
